var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "chicken-road-home" },
    [
      _vm.$screen.mobile
        ? _c("div", { staticClass: "home-header" }, [
            _vm._m(0),
            _c("div", { staticClass: "home-header__actions" }, [
              _c(
                "button",
                {
                  staticClass: "btn-how-to-play",
                  on: { click: _vm.handleOpenRulesModal },
                },
                [
                  _c("span", { staticClass: "btn-how-to-play__text" }, [
                    !_vm.isShowRoleplayingButton
                      ? _c("span", [_vm._v("how to play?")])
                      : _c("span", [_vm._v("?")]),
                  ]),
                ]
              ),
              _c(
                "button",
                {
                  staticClass: "btn-settings",
                  on: { click: _vm.handleToggleSettings },
                },
                [
                  _c("i", {
                    staticClass: "icon icon_gear-bold btn-settings__icon",
                  }),
                ]
              ),
            ]),
          ])
        : _vm._e(),
      _vm.$screen.mobile
        ? _c("difficulty-game", {
            attrs: {
              "selected-mode": _vm.gameState.selectedMode,
              "current-game": _vm.gameState.currentGame,
            },
            on: {
              "update:selectedMode": function ($event) {
                return _vm.$set(_vm.gameState, "selectedMode", $event)
              },
              "update:selected-mode": function ($event) {
                return _vm.$set(_vm.gameState, "selectedMode", $event)
              },
              "change-mode": _vm.handleModeChange,
            },
          })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "game-card" },
        [
          _c(
            "div",
            { staticClass: "game-card__controls-wrapper" },
            [
              !_vm.$screen.mobile
                ? _c("difficulty-game", {
                    attrs: {
                      "selected-mode": _vm.gameState.selectedMode,
                      "current-game": _vm.gameState.currentGame,
                    },
                    on: {
                      "update:selectedMode": function ($event) {
                        return _vm.$set(_vm.gameState, "selectedMode", $event)
                      },
                      "update:selected-mode": function ($event) {
                        return _vm.$set(_vm.gameState, "selectedMode", $event)
                      },
                      "change-mode": _vm.handleModeChange,
                    },
                  })
                : _vm._e(),
              _c(
                "div",
                {
                  class: [
                    "game-card__controls-inner",
                    { "glass-container": !_vm.$screen.mobile },
                  ],
                },
                [
                  _c(
                    "div",
                    {
                      class: [
                        "game-card__bet-wrapper",
                        { "glass-container": _vm.$screen.mobile },
                      ],
                    },
                    [
                      _vm.betType === _vm.BetType.BALANCE
                        ? _c("bet-creator-ratios", {
                            attrs: {
                              "bet-amount-usd": _vm.gameState.betAmount,
                              "balance-usd": _vm.allBalance,
                              "current-game": _vm.gameState.currentGame,
                            },
                            on: {
                              "update:betAmountUsd": function ($event) {
                                return _vm.$set(
                                  _vm.gameState,
                                  "betAmount",
                                  $event
                                )
                              },
                              "update:bet-amount-usd": function ($event) {
                                return _vm.$set(
                                  _vm.gameState,
                                  "betAmount",
                                  $event
                                )
                              },
                            },
                          })
                        : _c("bet-component", {
                            attrs: { "is-authenticated": _vm.isAuthenticated },
                          }),
                      _c(
                        "div",
                        { staticClass: "game-card__bet-actions" },
                        [
                          _c("bet-take", {
                            attrs: {
                              "current-game": _vm.gameState.currentGame,
                              "is-creating-game": _vm.gameState.isCreatingGame,
                              "is-making-step": _vm.gameState.isMakingStep,
                              "is-animating": _vm.gameState.isAnimating,
                              "is-ending-game": _vm.gameState.isEndingGame,
                              "bet-type": _vm.gameState.betType,
                              betAmountUsd: _vm.gameState.betAmount,
                            },
                            on: { "end-game": _vm.handleEndGame },
                          }),
                          _c("bet-creator", {
                            ref: "betCreator",
                            attrs: {
                              "is-authenticated": _vm.isAuthenticated,
                              "current-game": _vm.gameState.currentGame,
                              "is-creating-game": _vm.gameState.isCreatingGame,
                              "is-making-step": _vm.gameState.isMakingStep,
                              "is-animating": _vm.gameState.isAnimating,
                              "bet-type": _vm.gameState.betType,
                              betAmountUsd: this.gameState.betAmount,
                              "check-balance-handler": _vm.checkBalance,
                            },
                            on: {
                              "open-login": _vm.handleOpenLoginModal,
                              "create-game": _vm.handleCreateGame,
                              "make-step": _vm.handleMakeStep,
                              "reset-game": _vm.handleResetGame,
                              "notify-error": _vm.handleShowError,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              !_vm.$screen.mobile
                ? _c(
                    "div",
                    { staticClass: "game-card__pc-badges" },
                    [
                      _c("online-count-badge", {
                        attrs: { count: _vm.onlineCount },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("chicken-road-game-field", {
            staticClass: "game-card__field",
            attrs: {
              chickenRoadState: _vm.gameState,
              soundsService: _vm.soundsService,
              settingsState: _vm.settingsState,
            },
          }),
          _vm.$screen.mobile
            ? _c("online-count-badge", {
                attrs: { count: _vm.onlineCount, isAbsolute: true },
              })
            : _vm._e(),
          !_vm.$screen.mobile
            ? _c("home-actions", {
                attrs: { settingsState: _vm.settingsState },
                on: {
                  "open-how-game-works-dialog": _vm.handleOpenRulesModal,
                  "settings-tooltip-toggle": _vm.handleToggleSettings,
                  "update:settingsState": function ($event) {
                    _vm.settingsState = $event
                  },
                  "update:settings-state": function ($event) {
                    _vm.settingsState = $event
                  },
                },
              })
            : _vm._e(),
          _c("current-game", { attrs: { chickenRoadState: _vm.gameState } }),
        ],
        1
      ),
      _c("last-wins", {
        attrs: {
          "is-authenticated": _vm.isAuthenticated,
          chickenRoadState: _vm.gameState,
          "currency-type": _vm.currencyType,
        },
      }),
      _c(
        "Modal",
        {
          attrs: {
            "class-name": "app-modal notice-modal",
            "footer-hide": "",
            width: "'438rem'",
            closable: false,
          },
          model: {
            value: _vm.notice_modal_show,
            callback: function ($$v) {
              _vm.notice_modal_show = $$v
            },
            expression: "notice_modal_show",
          },
        },
        [
          _c(
            "InteractivePanel",
            {
              attrs: { title: "Chicken Road 玩法说明", has_close_button: "" },
              on: {
                close_button_click: function () {
                  _vm.notice_modal_show = false
                },
              },
            },
            [
              _c("div", { staticClass: "text-content" }, [
                _c("p", [
                  _vm._v(
                    "这很简单：选择适合你的难度级别，然后输入金额——使用你的余额或欢乐豆。"
                  ),
                ]),
                _c("br"),
                _c("p", [
                  _vm._v(
                    "点击“开始游戏”，等待回合开始，然后按下“迈出一步”，小鸡就会跳过平台。"
                  ),
                ]),
                _c("br"),
                _c("p", [
                  _vm._v("每次跳跃，乘数都会增加——你的潜在奖励也会增加。"),
                ]),
                _c("br"),
                _c("p", [
                  _vm._v("你可以随时兑现你的奖励。只要确保在鸡烧焦之前兑现。"),
                ]),
                _c("br"),
                _c("p", [
                  _vm._v("如果你准备好承担风险，那就放手一搏，争取一举成功！"),
                ]),
                _c("br"),
                _c("p", [_vm._v("祝你好运，享受比赛！ 🐔🔥")]),
              ]),
            ]
          ),
        ],
        1
      ),
      _c("c-RewardModal", {
        ref: "reward_ui",
        attrs: {
          background: require("./assets/logo.png"),
          "auto-convert-currency-type": _vm.currencyType,
          resetText: _vm.isAutoConverted ? "关闭" : "存入背包",
        },
        on: { "on-close": _vm.handleResetGame },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "home-header__title-group" }, [
      _c("i", { staticClass: "icon_new icon_Chiken home-header__icon" }),
      _c("span", { staticClass: "home-header__title" }, [
        _vm._v("Chicken Road"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }